export function isDesktop(): boolean {
  return typeof window !== "undefined";
}

export function isMobile(): boolean {
  return isDesktop() && window.innerWidth < 768;
}
